<script lang="ts">
    import type { CustomerReviews } from '@shared/types/types.ts';

    interface Props {
        customerReviews: CustomerReviews | undefined;
    }

    let { customerReviews }: Props = $props();

    type StarName = 'rating-filled' | 'rating-half' | 'rating-empty';
    type Stars = { name: StarName }[];

    const maxRating = 5;

    function starName(position: number, rating: number): StarName {
        if (position <= rating) return 'rating-filled';
        if (position - 0.5 === rating) return 'rating-half';
        return 'rating-empty';
    }

    let stars = $derived.by((): Stars => {
        const rating = customerReviews?.averageRating;
        if (!customerReviews?.amount || !rating) return [];
        return Array.from({ length: maxRating }, (_, i) => ({
            name: starName(i + 1, rating),
        }));
    });
</script>

{#if stars.length > 0}
    <!-- NOTE: Sheets are defined globally in TileList.svelte -->
    <!-- SEE: src/tilelist/components/rating-sheets/RatingSheets.svelte -->
    <div
        class="reptile-rating"
        data-oc-sheet-v1-open
        data-oc-sheet-v1-open.id="reptile-ratings-sheet"
        data-secondary-action
    >
        <div class="reptile-rating__stars">
            {#each stars as star, i (i)}
                <oc-icon-v1 type={star.name} size={'50'}></oc-icon-v1>
            {/each}
        </div>
        <span class="reptile-rating__amount">({customerReviews?.amount})</span>
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-rating {
        cursor: pointer;

        display: flex;
        flex-wrap: wrap;

        width: 100%;

        font: tokens.$oc-semantic-font-copy-75;
        text-decoration: none;

        &__stars {
            display: inline-flex;
            gap: tokens.$oc-semantic-spacing-absolute-12;
            align-items: center;
            margin-right: tokens.$oc-semantic-spacing-absolute-12;
        }

        &__amount {
            color: tokens.$oc-semantic-color-text-secondary;
        }
    }
</style>
